import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4)
  }
}));

export const ButtonCnt = styled('section')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1)
}));
